/*
Supported languages:
- Turkish
- English
- German
- Arabic
- Azerbaijani
- Bengali
- Persian
- Philippine
- French
- Hindi
- Spanish
- Italian
- Japanese
- Korean
- Russian
- Urdu
- Dutch
- Swedish
- Danish
- Norwegian
- Romanian
- Polish
- Ukrainian
- Greek
- Finnish
- Czech
- Bulgarian
- Hungarian

Chinese and Portuguese history files are the same as English
 */


export const videoTitlesInDifferentLanguages = [
    "(.*) adlı videoyu izlediniz",
    "Watched (.*)",
    "(.*) angesehen",
    "تمت مشاهدة (.*) .",
    "(.*) izlənildi",
    "(.*) দেখা হয়েছে",
    "را تماشا کردید (.*)",
    "Pinanood ang (.*)",
    "Vous avez regardé (.*)",
    "(.*) देखा",
    "Has visto (.*)",
    "Hai guardato (.*)",
    "(.*) を視聴しました",
    "(.*) 을(를) 시청했습니다.",
    "Просмотрено видео (.*)",
    "(.*) دیکھی",
    "Je hebt naar (.*) gekeken",
    "Tittade på (.*)",
    "Så (.*)",
    "Så på (.*)",
    "Ați vizionat (.*)",
    "Obejrzano: (.*)",
    "Ви дивилися відео (.*)",
    "Παρακολουθήσατε το βίντεο (.*)",
    "(.*) katsottiin",
    "Zhlédli jste video (.*)",
    "Гледахте (.*)",
    "Megtekintette a következőt: (.*)",
];

export const watchHistoryInDifferentLanguages = [
    "YouTube izleme geçmişi",
    "YouTube watch history",
    "YouTube-Wiedergabeverlauf",
    "سجلّ مشاهدة YouTube",
    "YouTube baxış tarixçəsi",
    "YouTube দেখার ইতিহাস",
    "سابقه تماشای YouTube",
    "History ng panonood sa YouTube",
    "Historique des vidéos regardées sur YouTube",
    "YouTube देखने का इतिहास",
    "Historial de reproducciones de YouTube",
    "Cronologia delle visualizzazioni di YouTube",
    "YouTube の再生履歴",
    "YouTube 시청 기록",
    "История просмотра YouTube",
    "YouTube دیکھنے کی سرگزشت",
    "YouTube-kijkgeschiedenis",
    "Visningshistorik på YouTube",
    "Afspilningshistorik på YouTube",
    "YouTube-seerlogg",
    "Istoricul vizionărilor YouTube",
    "Historia oglądania w YouTube",
    "Історія переглядів YouTube",
    "Ιστορικό παρακολούθησης YouTube",
    "YouTube-katseluhistoria",
    "Historie sledování YouTube",
    "История на гледане в YouTube",
    "YouTube-os megtekintési előzmények",
];
